export type Language = 'zh' | 'en';

export interface SEOConfig {
  [route: string]: {
    title: Record<Language, string>;
    description: Record<Language, string>;
    keywords: Record<Language, string[]>;
  };
}

export const SEO_CONFIG: SEOConfig = {
  '/': {
    title: {
      zh: '研达创新EETL | 电子元器件定制与批量采购| TAIYO HRS授权代理商',
      en: 'EETL Electronics - Custom Components & Bulk Order'
    },
    description: {
      zh: '研达创新EETL是国内领先的电子元器件供应链解决方案提供商，公司致力成为优秀的电子元器件代理及增值服务提供商。代理产品线包括TAIYO YUDEN、ELNA、HRS、PROSEMI、ROHM、SUNWAY、INVSEMI等知名品牌，提供电容器、电感器、连接器等高品质元器件及一站式服务。覆盖消费电子、通信、汽车电子、智能驾驶、新能源动力、工业控制、新能源储能及AI服务器、AI机器人行业，依托香港、深圳、上海三地物流及多元化业务平台中心，确保高效、可靠的供应链支持。',
      en: 'Professional electronic component distributor and value-added service provider'
    },
    keywords: {
      zh: ['工业级电子元器件', '汽车级电子元器件', '电子元器件代理商', '高性能电容器', '工业级电感器', '定制电子元器件解决方案', 'TAIYO/HRS授权代理商'],
      en: ['Electronics components', 'Capacitors', 'Inductors', 'Connectors']
    }
  },
  '/aboutus': {
    title: {
    zh: '关于我们 - EETL电子元件',
    en: 'About Us - EETL Electronics'
    },
    description: {
        zh: '研达创新电子（EETL）成立于1997年，总部位于深圳南山区，专注于为消费电子、通信、汽车电子、智能驾驶、新能源动力、工业控制、新能源储能及AI服务器、AI机器人等行业提供专业的电子元器件供应链服务。公司与多家国际知名品牌（Taiyo/HRS等）建立长期合作关系，依托香港海外仓、深圳完税仓、上海保税仓的资源优势，覆盖中国、日本、泰国、新加坡、马来西亚、越南、中国台湾等地区。EETL凭借丰富的行业经验和全球化布局，为客户提供高效、可靠的供应链服务和增值解决方案。',
        en: 'Professional manufacturer of multilayer ceramic capacitors with full specifications'
    },
    keywords: {
        zh: ['研达创新EETL', 'EETL简介'],
        en: ['研达创新EETL', 'EETL简介']
    }
  },
  '/products': {
    title: {
      zh: '研达创新电子产品中心 – 高品质高可靠性电子元器件一站式供应',
      en: '研达创新电子产品中心 – 高品质高可靠性电子元器件一站式供应'
    },
    description: {
      zh: '研达创新EETL是多家国际品牌授权电子元器件代理商，包括TAIYO YUDEN、 HRS、 Rohm ELNA、Prosemi、信维通信、芯能等等，主营电容、电感、电阻、连接器、传感器等全品类电子元件，专注汽车电子、工业控制领域应用。依托香港/深圳/上海仓储网络，提供原厂直供的一站式采购服务，支持消费电子、通信、新能源、AI 机器人等行业方案定制，多年供应经验保障品质与交付效率',
      en: 'Professional manufacturer of multilayer ceramic capacitors with full specifications'
    },
    keywords: {
      zh: ['研达创新EETL', '电容电阻供应商', '汽车电子元器件', '工业控制元器件', '连接器传感器', '电子元器件原厂授权', '射频器件', '电子元器件一站式采购'],
      en: ['EETL', 'Ceramic Capacitor', 'Electronic Components']
    }
  },
  '/products-mlcc': {
    title: {
      zh: '片状多层陶瓷电容器 | TAIYO Yuden授权代理|汽车电子/通信领域应用 - EETL',
      en: 'MLCC Products - EETL Electronics'
    },
    description: {
      zh: '研达创新电子EETL是TAIYO YUDEN官方授权代理商，主营小尺寸大容量及高可靠性片状多层陶瓷电容器（MLCC），适用于汽车电子、通信基站、智能手机等领域。提供原厂直供、AEC-Q200认证产品，支持批量采购与客制化服务，依托深圳/香港/上海三地仓储，保障72小时快速交付。多年电子元件供应经验，服务多家高端中大型企业。',
      en: 'Professional manufacturer of multilayer ceramic capacitors with full specifications'
    },
    keywords: {
      zh: ['TAIYO YUDEN授权代理', '片状多层陶瓷电容器', '汽车电子电容器', '低ESR系列MLCC', '小尺寸大容量电容', '通信基站电容器', '原厂直供MLCC', '电子元件一站式采购'],
      en: ['TAIYO YUDEN授权代理', 'Ceramic Capacitor', 'Electronic Components']
    }
  },
  '/products-aluminum': {
    title: {
      zh: '铝电解电容器|  TAIYO YUDEN授权代理|长寿命/高耐压/低ESR - EETL',
      en: 'MLCC Products - EETL Electronics'
    },
    description: {
      zh: '研达创新电子EETL是TAIYO YUDEN官方授权代理商，提供105℃长寿命、5000小时耐久、低ESR系列产品，高安全性系列产品，适用于工业电源、新能源逆变器、变频器、汽车电子等场景。支持原厂直供、现货速发、定制化选型，依托深圳/香港/上海三仓协同，保障快速交付。多年电子元器件供应经验，提供稳定的质量和专业的服务',
      en: 'Professional manufacturer of multilayer ceramic capacitors with full specifications'
    },
    keywords: {
      zh: ['铝电解电容器代理商','TAIYO YUDEN铝电解电容器代理', '铝电解电容器', '长寿命铝电解电容', '高耐压铝电解电容', '低ESR铝电解电容', '工业电源电容器', '新能源电解电容', '电子元件一站式采购'],
      en: ['铝电解电容器代理商, TAIYO YUDEN铝电解电容器代理, 长寿命铝电解电容, 低ESR电解电容, 工业电源电容器, 新能源电解电容, 高耐压电容器', 'Ceramic Capacitor', 'Electronic Components']
    }
  },
  '/products-ferrite': {
    title: {
      zh: '铁氧磁珠电感器|  TAIYO YUDEN授权代理|高频噪声抑制/低阻抗- EETL',
      en: 'MLCC Products - EETL Electronics'
    },
    description: {
      zh: '研达创新电子EETL是TAIYO YUDEN官方授权的铁氧体磁珠电感器代理商，研达创新电子（EETL）代理的铁氧体磁珠电感器，采用先进工艺，具有高磁导率、低损耗、热稳定性等特点。提供100MHz-3GHz高频噪声抑制、阻抗0.1Ω-2000Ω全系产品，适用于电源滤波、通信设备EMI抑制及汽车电子场景。支持原厂AEC-Q200认证型号，选择EETL，就是选择卓越的性能、稳定的质量和专业的服务。',
      en: 'Professional manufacturer of multilayer ceramic capacitors with full specifications'
    },
    keywords: {
      zh: ['铁氧体磁珠电感器代理商','TAIYO YUDEN铁氧体磁珠电感器代理', '高频噪声抑制电感', '低阻抗磁珠', '电源滤波电感器', 'EMI抑制解决方案', '通信设备电感器'],
      en: [ 'Ceramic Capacitor', 'Electronic Components']
    }
  },
  '/products-inductor': {
    title: {
      zh: '功率电感器|  TAIYO YUDEN授权代理|高效率低电阻- EETL',
      en: 'MLCC Products - EETL Electronics'
    },
    description: {
      zh: '研达创新电子EETL是TAIYO YUDEN官方授权的功率电感器代理商，专业供应高频低损耗功率电感器，支持 350A 大电流与 - 20°C~+125°C 宽温工作，通过原厂 AEC-Q200 认证。提供客制化服务、快速交付与全链路技术支持，服务新能源汽车、工业控制、储能等领域。',
      en: 'Professional manufacturer of multilayer ceramic capacitors with full specifications'
    },
    keywords: {
      zh: ['功率电感器代理商','TAIYO YUDEN功率电感器代理', '功率电感器', '高效率低电阻', '大电流承载', '稳定电源输出', '消费电子电感器', '汽车电子电感器', '工业控制电感器'],
      en: ['Ceramic Capacitor', 'Electronic Components']
    }
  },
  '/products-ceramic': {
    title: {
      zh: 'LTCC器件|  TAIYO YUDEN授权代理|高频低损耗/微型化封装 -- EETL',
      en: 'MLCC Products - EETL Electronics'
    },
    description: {
      zh: '研达创新电子EETL是TAIYO YUDEN官方授权的LTCC器件代理商，提供高频低损耗（插入损耗≤0.5dB@6GHz）、小型化封装系列，专为5G基站滤波器、汽车毫米波雷达、物联网模组设计。广泛应用于通信、雷达、消费电子、汽车电子等场景',
      en: 'Professional manufacturer of multilayer ceramic capacitors with full specifications'
    },
    keywords: {
      zh: ['LTCC器件','TAIYO YUDEN LTCC器件代理', 'LTCC器件', '高频滤波器', '5G通信器件', '汽车雷达模块', '射频前端模块', '移动通信LTCC', '微型化射频元件', '原厂授权射频器件'],
      en: ['Ceramic Capacitor', 'Electronic Components']
    }
  },
  '/products-fbarsaw': {
    title: {
      zh: 'FBAR&SAW器件 |  TAIYO YUDEN授权代理|高频低损耗/微型化封装 -- EETL',
      en: 'MLCC Products - EETL Electronics'
    },
    description: {
      zh: '研达创新电子（EETL）是TAIYO YUDEN 授权的FBAR&SAW器件代理商，采用先进工艺、低插入损耗、优异的温度特性和高频性能。产品广泛应用于移动通信、汽车电子等领域。选择EETL，就是选择卓越的性能、稳定的质量和专业的服务。',
      en: 'Professional manufacturer of multilayer ceramic capacitors with full specifications'
    },
    keywords: {
      zh: ['FBAR&SAW器件, TAIYO YUDEN 射频器件代理,高性能射频器件, 射频前端模块, 移动通信滤波器, 汽车电子滤波器, 高可靠性射频器件'],
      en: ['FBAR&SAW器件, TAIYO YUDEN 射频器件代理,高性能射频器件, 高Q值滤波器, 射频前端模块, 移动通信滤波器, 汽车电子滤波器, 高可靠性射频器件']
    }
  },
  '/joinus': {
    title: {
      zh: '加入我们 - EETL电子元件',
      en: 'Join Us - EMBEDDED EVOLUTION ELECTRONICS TECHNOLOGY LTD' 
    },
    description: {
      zh: '加入我们 - EETL电子元件',
      en: 'Join Us - EMBEDDED EVOLUTION ELECTRONICS TECHNOLOGY LTD'
    },
    keywords: {
      zh: ['加入我们', 'EETL电子元件'],
      en: ['Join Us', 'EMBEDDED EVOLUTION ELECTRONICS TECHNOLOGY LTD.']
    }
  },
  '/products/connector/ConnectorBTB': {
    title: {
      zh: '板对板连接器 | HRS授权代理 | 高可靠性/高密度连接解决方案 - EETL',
      en: 'Board-to-Board Connectors - HRS Authorized Agent | High Reliability Solutions'
    },
    description: {
      zh: '研达创新EETL是HRS官方授权的BTB连接器代理商，提供高可靠性、高密度的板对板连接解决方案。产品广泛应用于消费电子、通信设备、汽车电子等领域，支持高速信号传输和稳定电源连接。',
      en: 'Professional BTB connector solutions with high reliability and density'
    },
    keywords: {
      zh: ['板对板连接器', 'HRS连接器代理', '高密度连接器', '高速信号连接器', '汽车电子连接器', '消费电子连接器'],
      en: ['BTB Connectors', 'Board-to-Board Connectors', 'High Density Connectors']
    }
  },
  '/products/connector/ConnectorZIF': {
    title: {
      zh: 'ZIF连接器 | HRS授权代理 | 零插入力/高可靠性连接方案 - EETL',
      en: 'ZIF Connectors - HRS Authorized Agent | Zero Insertion Force Solutions'
    },
    description: {
      zh: '研达创新EETL是HRS官方授权的ZIF连接器代理商，提供零插入力、高可靠性的连接解决方案。产品适用于FPC/FFC连接，广泛应用于消费电子、显示设备、汽车电子等领域。',
      en: 'Professional ZIF connector solutions with zero insertion force'
    },
    keywords: {
      zh: ['ZIF连接器', 'HRS连接器代理', '零插入力连接器', 'FPC连接器', 'FFC连接器', '显示设备连接器', '汽车电子连接器'],
      en: ['ZIF Connectors', 'Zero Insertion Force Connectors', 'FPC/FFC Connectors']
    }
  },
  '/products/connector/ConnectorWTB': {
    title: {
      zh: '线对板连接器 | HRS授权代理 | 线对板/高可靠性连接方案 - EETL',
      en: 'Wire-to-Board Connectors - HRS Authorized Agent | Wire-to-Board Solutions'
    },
    description: {
      zh: '研达创新EETL是HRS官方授权的WTB连接器代理商，提供高可靠性、易组装的线对板连接解决方案。产品广泛应用于消费电子、工业设备、汽车电子等领域。',
      en: 'Professional WTB connector solutions with high reliability'
    },
    keywords: {
      zh: ['HRS连接器代理', '线对板连接器', '工业连接器', '汽车电子连接器', '消费电子连接器'],
      en: ['WTB Connectors', 'Wire-to-Board Connectors', 'Industrial Connectors']
    }
  },
  '/products/connector/ServicePlug': {
    title: {
      zh: '维修检测开关 | HRS授权代理 | 高可靠性/易维护连接方案 - EETL',
      en: 'Service Plug - HRS Authorized Agent | High Reliability Solutions'
    },
    description: {
      zh: '研达创新EETL是HRS官方授权的Service Plug连接器代理商，提供高可靠性、易维护的连接解决方案。产品广泛应用于工业设备、汽车电子、通信设备等领域。',
      en: 'Professional Service Plug connector solutions with high reliability'
    },
    keywords: {
      zh: ['维修检测开关', 'HRS连接器代理', '工业连接器', '汽车电子连接器', '通信设备连接器'],
      en: ['Service Plug', 'Industrial Connectors', 'Automotive Connectors']
    }
  },
  '/products/connector/ConnectorMC': {
    title: {
      zh: '细线同轴连接器 | HRS授权代理 | 高可靠性/多功能连接方案 - EETL',
      en: 'Multi-function Connectors - HRS Authorized Agent | High Reliability Solutions'
    },
    description: {
      zh: '研达创新EETL是HRS官方授权的MC连接器代理商，提供高可靠性、多功能的连接解决方案。产品广泛应用于消费电子、工业设备、汽车电子等领域。',
      en: 'Professional Multi-function Connectors with high reliability'
    },
    keywords: {
      zh: ['细线同轴连接器', 'HRS连接器代理', '多功能连接器', '工业连接器', '汽车电子连接器', '消费电子连接器'],
      en: ['Multi-function Connectors', 'Industrial Connectors']
    }
  },
  '/products/connector/ConnectorAuto': {
    title: {
      zh: '汽车用连接器 | HRS授权代理 | 汽车电子/高可靠性连接方案 - EETL',
      en: 'Automotive Connectors - HRS Authorized Agent | Automotive Electronics Solutions'
    },
    description: {
      zh: '研达创新EETL是HRS官方授权的汽车用连接器代理商，提供高可靠性、专为汽车电子设计的连接解决方案。产品广泛应用于新能源汽车、智能驾驶、汽车电子系统等领域。',
      en: 'Professional automotive connector solutions with high reliability for automotive electronics'
    },
    keywords: {
      zh: ['汽车用连接器', 'HRS连接器代理', '汽车电子连接器', '新能源汽车连接器', '智能驾驶连接器', '汽车系统连接器'],
      en: ['Automotive Connectors', 'Car Electronics Connectors', 'New Energy Vehicle Connectors']
    }
  },
};